export const TID = {
    // Nav
    navJoin: "nav-join-waitlist-btn",
    navLogo: "nav-logo",
    // Hero
    heroLogo: "hero-logo",
    heroWordmark: "hero-wordmark",
    heroHeadline: "hero-headline",
    heroJoinBtn: "hero-waitlist-btn",
    heroVisionBtn: "hero-vision-btn",
    // What is
    whatIsSection: "what-is-section",
    whatIsCard: "what-is-card",
    // Who for
    whoForSection: "who-for-section",
    whoForCard: "who-for-card",
    // Problem
    problemSection: "problem-section",
    // Solution
    solutionSection: "solution-section",
    solutionTab: "solution-tab",
    // Waitlist
    waitlistSection: "waitlist-section",
    waitlistName: "waitlist-name-input",
    waitlistOrg: "waitlist-org-input",
    waitlistEmail: "waitlist-email-input",
    waitlistSubmit: "waitlist-submit-btn",
    waitlistSuccess: "waitlist-success",
    // Vision
    visionSection: "vision-section",
    // Footer
    footer: "site-footer",
    footerLink: "footer-link",
};

export const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_lambda-quest-landing/artifacts/6pcfmcg7_ChatGPT%20Image%20Jun%2025%2C%202026%2C%2012_50_13%20AM.png";

export const WORDMARK_URL =
    "https://customer-assets.emergentagent.com/job_lambda-quest-landing/artifacts/oby5flsx_ChatGPT%20Image%20Jun%2025%2C%202026%2C%2001_00_23%20AM.png";
